<template>
  <div v-if="course" class="container container--backgrounded">

    <div class="course-header">
      <div class="content-column course">
        <div class="course-bg" v-bind:style="{ 'background-image': 'url(/images/courses/' + course.id + '/' + course.image + ')' }"></div>

        <h1 class="course__title">{{ course.title }}</h1>
        <div class="course__about">{{ course.about }}</div>
        <div class="course__lessons_counter">{{ course.lessons_counter }}</div>
        <div class="course__controls">
          <button class="round-button round-button-blue-inverse" @click.prevent="studyCourse()">{{ $t('study_course') }}</button>
          <button class="round-button round-button-blue-second" @click.prevent="learnMore()">{{ $t('learn_more') }}</button>
        </div>
      </div>
    </div>

    <article class="course-content" id="course-content">
      <div class="content-column">
        <content-editor v-model="course.description" :options="options" :controls="false"></content-editor>
      </div>
    </article>

    <div class="course-lessons">
      <h2 class="course-lessons__header">Занятия курса</h2>
      <div class="course-lessons__cards lesson-cards">
        <lesson-card :key=key :lesson-id="lesson.id" :course-id="course.id" :lesson="lesson" v-for="(lesson, key) in course.lessons"></lesson-card>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, } from 'vuex';
  import ContentEditor from '~/components/ContentEditor';
  import LessonCard from '~/components/LessonCard';

  export default {
    metaInfo () {
      return { title: this.course ? this.course.title : '', };
    },
    components: {
      LessonCard,
      ContentEditor,
    },
    data: () => ({
      studying: false,
      options: {
        postImageUrl: '',
        postFileUrl: '',
        baseImagePath: '',
        baseFilePath: '',
      },
    }),
    computed: mapGetters({
      user: 'auth/user',
      course: 'courses/course',
      loginModal: 'modals/login',
    }),
    methods: {
      async studyCourse () {
        if (!this.user) {
          this.$store.dispatch('modals/showLogin');
        } else {
          const firstLesson = this.course.lessons[0];
          if (firstLesson && firstLesson.id) {
            if (this.user && this.user.user_lessons.find(el => el.id === firstLesson.id) === undefined) {
              await this.$store.dispatch('auth/study', firstLesson);
              await this.$store.dispatch('auth/fetchUser');
              this.studying = true;
            }
            this.$router.push({ name: 'lesson.view', params: { courseId: this.course.id, id: firstLesson.id } });
          }
        }
      },
      learnMore () {
        document.getElementById('course-content').scrollIntoView({ block: 'start', behavior: 'smooth' });
      },
    },
    async beforeMount () {
      this.$store.dispatch('courses/clearCourse');
      const courseId = parseInt(this.$route.params.id);

      this.options.postImageUrl = '/api/courses/' + courseId + '/images';
      this.options.postFileUrl = '/api/courses/' + courseId + '/files';
      this.options.baseImagePath = '/images/courses/' + courseId;
      this.options.baseFilePath = '/files/courses/' + courseId;

      if (this.user) {
        this.studying = this.user.user_courses.find(el => el.id === courseId) !== undefined;
      }

      this.$store.dispatch('courses/find', courseId).then(() => {
        this.$store.dispatch('pages/stopLoading');
        this.$store.dispatch('pages/setBreadcrumbs', [
          {
            title: 'Главная',
            route: { name: 'home' },
          },
          {
            title: this.course.title,
          },
        ]);
      });

      this.$store.dispatch('pages/setControls', [
        {
          url: '/admin/courses/edit/' + courseId,
          label: 'Редактировать',
          roles: ['admin', 'curator', 'teacher']
        }
      ]);
    },
  };
</script>
